/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WithdrawalLimitsChangeLogResponseItem } from './withdrawal-limits-change-log-response-item';


export interface WithdrawalLimitsChangeLogResponseItemPagedList { 
    totalCount?: number;
    items?: Array<WithdrawalLimitsChangeLogResponseItem> | null;
}

